import React from "react";

const CustomChevronRight: React.FC = () => {
    return (
        <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="presentation"
        >
            <path d="M12.0923 1.18501L23.4998 12.5925L12.0923 24" stroke="#545454" stroke-width="2" />
        </svg>
    );
};

export default React.memo(CustomChevronRight);
